import { ActionReducerMapBuilder, createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Order, OrderItemType, OrderState, PaymentLinkResponse } from "../../types/orderTypes";
import { api } from "../../config/Api";
import { Address } from "../../types/userType";
import { ApiResponse } from "../../types/apiResponse";



const initialState: OrderState = {
  orders: [],
  orderItem: null,
  currentOrder: null,
  paymentOrder: null,
  loading: false,
  error: null,
  orderCanceled: false,
  isSuccess: null
};
const BASE_URL = "/api/order";
// The string "orders/fetchUserOrderHistory" is only an identifier for Redux to track actions (e.g., pending, fulfilled, or rejected).
export const fetchUserOrderHistory = createAsyncThunk<any[],undefined>(
  "order/fetchUserOrderHistory", async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE_URL}/user`)
      
      return response.data
    } catch (error: any) {
     
      return rejectWithValue(
        error.response.data.error || "Failed to fetch order History"
      )
    }
  }


)

export const fetchOrderById = createAsyncThunk<
  Order, // Return type of the async thunk
  number  // Argument type
>(
  "order/fetchOrderById",
  async (orderId , { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE_URL}/${orderId}`, {
      })
      return response.data;
    } catch (error: any) {
    
      return rejectWithValue("Failed to fetch order");
    }
  }
);

// Create a new order
export const createOrder = createAsyncThunk<
  PaymentLinkResponse, // Return type of the async thunk
  number
   // Argument type
>(
  "order/createOrder",
  async ( addressId , { rejectWithValue }) => {
    try {
     
      const response = await api.post<PaymentLinkResponse>(`${BASE_URL}/create/${addressId}`)

      if (response.data.paymentId) {
        window.location.href = response.data.paymentId;
      }
     
      return response.data;
    } catch (error: any) {
   
      return rejectWithValue("Failed to create order");
    }
  }
);

export const getOrderItemById = createAsyncThunk<
  OrderItemType, // Return type of the async thunk
  number// Argument type
>(
  "order/getOrderItem",
  async (orderItemId , { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE_URL}/item/${orderItemId}`)
      
     
      return response.data;
    } catch (error: any) {
   
      return rejectWithValue("Failed to get order item");
    }
  }
);


export const cancelOrder = createAsyncThunk<
  Order, // Return type of the async thunk
  
  number
 
>(
  "order/cancelOrder",
  async ( orderId , { rejectWithValue }) => {
    try {
      const response = await api.delete(`${BASE_URL}/${orderId}/cancel`)

    

      return response.data;
    } catch (error: any) {
    
      return rejectWithValue("Failed to get order item");
    }
  }
);

// payment successhandler
export const paymentSuccessHandler = createAsyncThunk<boolean,   string , { rejectValue: string }>(
  "order/paymentSuccessHandler",
  async (paymentId , { rejectWithValue }) => {
    try {
      const response = await api.get(`/api/payment/${paymentId}`)
     
      return response.data.success
    } catch (error: any) {
     
      return rejectWithValue(
        error.response.data.message
      )
    }
  }
)
export const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    resetOrderState: (state) => {
      state.orders = [];
      state.loading = false;
      state.error = null;
      state.isSuccess = null;
      state.orderCanceled = false
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<OrderState>) => {
    // fetch user order history
    builder.addCase(fetchUserOrderHistory.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.orderCanceled = false
    })
      .addCase(fetchUserOrderHistory.fulfilled, (state, action: PayloadAction<Order[]>) => {
        state.loading = false;
        state.orders = action.payload;

      })
      .addCase(fetchUserOrderHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      //fetch order by Id
      .addCase(fetchOrderById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrderById.fulfilled, (state, action: PayloadAction<Order>) => {
        state.loading = false;
        state.currentOrder = action.payload;
      })
      .addCase(fetchOrderById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Create a new order
      .addCase(createOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createOrder.fulfilled, (state, action: PayloadAction<PaymentLinkResponse>) => {
        state.loading = false;
        state.paymentOrder = action.payload;
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // getOrderItem
      .addCase(getOrderItemById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOrderItemById.fulfilled, (state, action: PayloadAction<OrderItemType>) => {
        state.loading = false;
        state.orderItem = action.payload;
      })
      .addCase(getOrderItemById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // payment success
      .addCase(paymentSuccessHandler.pending, (state) => {
        state.loading = true
      })
      .addCase(paymentSuccessHandler.fulfilled, (state, action: PayloadAction<boolean>) => {
        state.loading = false;
        state.isSuccess = action.payload;
      })
      .addCase(paymentSuccessHandler.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;

      })
      // cancelOrder
      // For each order, it checks if the id matches the id of the action.payload (the updated order returned by the API).
      // If the id matches, it replaces that specific order in the array with the new data (action.payload).
      // If the id does not match, the order remains unchanged.
      .addCase(cancelOrder.pending, (state) => {
        state.loading = true
      })
      .addCase(cancelOrder.fulfilled, (state, action: PayloadAction<Order>) => {
        state.loading = false;
        state.orders = state.orders.map((order) => order.id === action.payload.id ? action.payload : order)
        state.orderCanceled = true;
        state.currentOrder = action.payload
      })
      .addCase(cancelOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.orderCanceled = false;
      })
  }
})

export const orderSliceReducer = orderSlice.reducer;